import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick"];
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */
import { Button } from 'foundations-components/transitional/components/Button';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { FORM_ACTION_IDS } from 'asset-actions-lib-forms/constants/actionIds';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import usePatchForm from 'asset-actions-lib-forms/unpublish/hooks/usePatchForm';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UnpublishActionButton(_ref) {
  let {
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    onActionError,
    onActionSuccess,
    crmObject
  } = useAssetActions();
  const {
    patchForm
  } = usePatchForm();
  const formGuid = getPropertyValue(crmObject, 'hs_form_id') || '';
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    return patchForm({
      formGuid,
      data: {
        enabled: false
      }
    }).then(() => {
      if (onActionSuccess) {
        onActionSuccess({
          actionId: FORM_ACTION_IDS.UNPUBLISH,
          data: {
            crmObject
          }
        });
      }
    }).catch(() => {
      if (onActionError) {
        onActionError({
          actionId: FORM_ACTION_IDS.UNPUBLISH
        });
      }
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    use: "link",
    onClick: handleClick
  }));
}